function update_participantes_metodo_pago(participantes) {

    //Revisar bé Pep Porcuna. 2017-09-01
    //$.each(participantes, function (index, e) {
    //    if (typeof(e.metodo_pago) !== 'undefined') {
    //        if (typeof(e.metodo_pago.tipo_pago_escogido.precio) !== 'undefined') {
    //            var creditosOprecio = e.metodo_pago.tipo_pago_escogido.precio;
    //        } else {
    //            var creditosOprecio = e.metodo_pago.tipo_pago_escogido.creditos;
    //        }
    //
    //        var selected_soci_btn = $(selected_soci_btn_template).clone();
    //        //$(selected_soci_btn).find('.userImageDiv img').html(imagen(e.path_imagen));
    //        $(selected_soci_btn).find('.userNombre').html(e.nombre + " " + e.apellidos);
    //        $(selected_soci_btn).find('.info1').html("<strong>" + e.metodo_pago.tipo_pago_escogido.nombre + " / " + creditosOprecio + " " + e.metodo_pago.tipo_pago_escogido.unidades + "</strong>");
    //           $("#socis-list").find("#" + e.id_mst_socios).html(selected_soci_btn);
    //    }
    //});

    if (participantes !== undefined)
    {
        $.each(participantes, function (index, e) {

            if (typeof(e.metodo_pago) !== 'undefined') {
                var contenido = "<p>" + e.nombre + " " + e.apellidos + "</p>" + "<p><strong>" ;
                if (e.metodo_pago.tipo_pago_escogido.id_mst_tipopago !== undefined) {
                    contenido = contenido + e.metodo_pago.tipo_pago_escogido.nombre;
                }

                if (typeof(e.metodo_pago.tipo_pago_escogido.precio) !== 'undefined') {
                    contenido = contenido + " / " + e.metodo_pago.tipo_pago_escogido.precio + " " + e.metodo_pago.tipo_pago_escogido.unidades;
                }
                contenido = contenido +  "</strong></p>";
                if(e.apuntado === 0){
                    contenido = contenido + "<button class='btn btn-default' id='eliminar_soci'>" + Lang.get('msg.delete') + "</button>";
                }

                $("#socis-list").find("#" + e.id_mst_socios).html(contenido);
            }
        });
    }

}
